module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo yellow-bg"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Lembrar senha")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onValidate($event)
      }
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.form.errors.has('ds_login')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.ds_login),
      expression: "form.ds_login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Informe seu Login ou E-mail",
      "name": "login"
    },
    domProps: {
      "value": (_vm.form.ds_login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "ds_login", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "ds_login"
    }
  }), _vm._v(" "), (_vm.errors.first('login')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('login')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "disabled": _vm.form.busy,
      "type": "submit"
    }
  }, [_vm._v("Recuperar senha")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "id": "login",
      "href": "/"
    }
  }, [_vm._v("Voltar para Login")])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6632fd53!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EsqueciMinhaSenha.vue
// module id = 1985
// module chunks = 1